import React from "react";
import Highlights from "./Highlights";
import ModuloProductoEtapa from "./ModuloProductoEtapa";
import CarouselAliados from "./CarouselAliados";
import Footer from "./Footer";
import { Link } from "react-router-dom";
// import {BrowserRouter as Router, HashRouter, Switch,Route,Link} from "react-router-dom";
import i18n from "../i18n/index.js";
import "../scss/Aliados.scss";

function Fedea() {
  return (
    <>
      <section className="aliado-Fedea">
        <div className="space"></div>
        <div className="Hero">
          <img
            className="banner-hero"
            src="/assets/hero-fedea.png"
            alt="hero"
          />
          <div className="info-banner">
            <div className="sectionclass">
              <p>Partners</p>
            </div>
            <div className="nombre-aliado">
              <img
                src="/assets/logo-fedea.svg"
                alt="logo"
                className="logo-aliado"
              />
              <Highlights
                classNameH="interna"
                firstLineH={i18n.t(
                  "partners.fedea.sectionOne.titleFirstLineHighlight"
                )}
                firstLine={i18n.t("partners.fedea.sectionOne.titleFirstLine")}
                secondLineH={i18n.t(
                  "partners.fedea.sectionOne.titleSecondLineHighlight"
                )}
                secondLine={i18n.t("partners.fedea.sectionOne.titleSecondLine")}
              />
            </div>
          </div>
        </div>
        <div className="descripccion py-5 mt-5 mt-md-0">
          <img
            src="/assets/deco-gold.svg"
            alt="deco"
            className="deco-descrips"
          />
          <div className="w-90">
            <div className="container">
              <div className="row px-3">
                <div className="col-32 px-0">
                  <img
                    src="/assets/logo-fedea-prodeman.png"
                    className="logo-aliado"
                  />
                </div>
                <div className="col-12 col-md-6 px-0 pl-md-3 d-flex align-items-center">
                  <p className="title-presentacion mb-3 mb-md-0">
                    {i18n.t("partners.fedea.sectionTwo.title01")}
                    <br />
                    {i18n.t("partners.fedea.sectionTwo.title02")}
                  </p>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <p className="text-aliado">
                    {i18n.t("partners.fedea.sectionTwo.desc01")}
                  </p>
                </div>
                <div className="col-md-6">
                  <p className="text-aliado">
                    {i18n.t("partners.fedea.sectionTwo.desc02")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="servicios py-5">
          <div className="blue-servicio"></div>
          <div className="little-gold"></div>
          <div className="big-gold"></div>
          <div className="grey-servicios"></div>
          <img src="/assets/gold-wave.svg" alt="deco" className="wave-03" />
          <div className="container">
            <div className="grey-servicio"></div>
            <h3>{i18n.t("partners.fedea.sectionThree.title")}</h3>
            <div className="row py-3 mx-3 mx-md-0">
              <div className="col-md-6 px-0 px-md-auto">
                <ModuloProductoEtapa
                  titleEtapa={i18n.t("partners.fedea.sectionThree.box01.title")}
                  imgEtapa="../assets/planta00.jpg"
                  infoEtapa={i18n.t("partners.fedea.sectionThree.box01.item01")}
                  infoEtapa2={i18n.t(
                    "partners.fedea.sectionThree.box01.item02"
                  )}
                  infoEtapa3={i18n.t(
                    "partners.fedea.sectionThree.box01.item03"
                  )}
                  infoEtapa4={i18n.t(
                    "partners.fedea.sectionThree.box01.item04"
                  )}
                />
              </div>
              <div className="col-md-6 px-0 px-md-auto">
                <ModuloProductoEtapa
                  titleEtapa={i18n.t("partners.fedea.sectionThree.box02.title")}
                  imgEtapa="../assets/planta0.jpg"
                  infoEtapa={i18n.t("partners.fedea.sectionThree.box02.item01")}
                  infoEtapa2={i18n.t(
                    "partners.fedea.sectionThree.box02.item02"
                  )}
                  infoEtapa3={i18n.t(
                    "partners.fedea.sectionThree.box02.item03"
                  )}
                  infoEtapa4={i18n.t(
                    "partners.fedea.sectionThree.box02.item04"
                  )}
                />
              </div>
              <div className="col-md-6 px-0 px-md-auto">
                <ModuloProductoEtapa
                  titleEtapa={i18n.t("partners.fedea.sectionThree.box03.title")}
                  imgEtapa="../assets/planta4.jpg"
                  infoEtapa={i18n.t("partners.fedea.sectionThree.box03.item01")}
                  infoEtapa2={i18n.t(
                    "partners.fedea.sectionThree.box03.item02"
                  )}
                  infoEtapa3={i18n.t(
                    "partners.fedea.sectionThree.box03.item03"
                  )}
                />
              </div>
              <div className="col-md-6 px-0 px-md-auto">
                <ModuloProductoEtapa
                  titleEtapa="V1 - Vn - R1 - R6 - R7"
                  imgEtapa="../assets/planta6.jpg"
                  infoEtapa={i18n.t("partners.fedea.sectionThree.box04.item01")}
                  infoEtapa2={i18n.t(
                    "partners.fedea.sectionThree.box04.item02"
                  )}
                  infoEtapa3={i18n.t(
                    "partners.fedea.sectionThree.box04.item03"
                  )}
                  infoEtapa4={i18n.t(
                    "partners.fedea.sectionThree.box04.item04"
                  )}
                />
              </div>
              <div className="col-md-6 px-0 px-md-auto">
                <ModuloProductoEtapa
                  titleEtapa={i18n.t("partners.fedea.sectionThree.box05.title")}
                  imgEtapa="../assets/planta13.jpg"
                  infoEtapa={i18n.t("partners.fedea.sectionThree.box05.item01")}
                  infoEtapa2={i18n.t(
                    "partners.fedea.sectionThree.box05.item02"
                  )}
                  infoEtapa3={i18n.t(
                    "partners.fedea.sectionThree.box05.item03"
                  )}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="fedea-ofrece">
          <img src="/assets/gold-wave.svg" alt="deco" className="wave-01" />
          <img src="/assets/gold-wave.svg" alt="deco" className="wave-02" />
          <div className="grey-bottom"></div>
          <div className="light-blue"></div>
          <div className="container">
            <h3 className="mb-4">
              {i18n.t("partners.fedea.sectionFour.title")}
            </h3>
            <div className="row">
              <div className="col-md-4 mb-4">
                <div className="ofrece">
                  <img src="/assets/1.svg" alt="1" className="number" />
                  <p className="text">
                    {i18n.t("partners.fedea.sectionFour.box01")}
                  </p>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="ofrece">
                  <img src="/assets/2.svg" alt="1" className="number" />
                  <p className="text">
                    {i18n.t("partners.fedea.sectionFour.box02")}
                  </p>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="ofrece">
                  <img src="/assets/3.svg" alt="1" className="number" />
                  <p className="text">
                    {i18n.t("partners.fedea.sectionFour.box03")}
                  </p>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="ofrece">
                  <img src="/assets/4.svg" alt="1" className="number" />
                  <p className="text">
                    {i18n.t("partners.fedea.sectionFour.box04")}
                  </p>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="ofrece">
                  <img src="/assets/5.svg" alt="1" className="number" />
                  <p className="text">
                    {i18n.t("partners.fedea.sectionFour.box05")}
                  </p>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="ofrece">
                  <img src="/assets/6.svg" alt="1" className="number" />
                  <p className="text">
                    {i18n.t("partners.fedea.sectionFour.box06")}
                  </p>
                  <a
                    target="_blank"
                    href="https://www.google.com/maps/d/edit?mid=1aicebE-iSv600djNiN1vSLGapa15WXJb&usp=sharing"
                  >
                    <b>{i18n.t("partners.fedea.sectionFour.dest")}</b>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="Beneficios py-5">
          <img
            src="/assets/gold-beneficios.svg"
            alt="deco"
            className="gold-beneficios"
          />
          <div className="container">
            <h4 className="mb-4">
              {i18n.t("partners.fedea.sectionSix.title")}
            </h4>
            <CarouselAliados />
          </div>
        </div>
        <div className="cta-aliados py-5">
          <div className="container">
            <div className="col-12">
              <div href="#" className="interesado-aliados">
                <Link to="/contacto">
                  <div className="row justify-content-center align-items-center">
                    <p>{i18n.t("partners.cta")}</p>
                    <img
                      src="/assets/arrow-next.svg"
                      alt="arrow"
                      className="arrow-cta"
                    />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Fedea;
